import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {CurrencySearchModel} from "../currency-search.model";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CurrencyTypeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-currency-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(CurrencySearchModel)
    ]
})
export class CurrencyTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<CurrencySearchModel> {
    constructor(model: CurrencySearchModel, injector: Injector) {
        super(model, injector, "id", "id");
    }
}
